<app-top-nav></app-top-nav>

<div class="main">
  <div class="flex-container">
    <div *ngIf="userManagerAllowed">
      <a routerLink="/admin/user">
        <mat-icon class="material-icons">people_outline</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.users">users</p>
        </div>
      </a>
    </div>
    <div *ngIf="documentTemplatesAllowed">
      <a routerLink="/admin/templates">
        <mat-icon class="material-icons">description</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.templates">
            templates
          </p>
        </div>
      </a>
    </div>
    <div *ngIf="initialLoadAllowed">
      <a routerLink="/admin/initial-load">
        <mat-icon class="material-icons">backup</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.initialload">
            initial load
          </p>
        </div>
      </a>
    </div>
    <div *ngIf="lstExportAllowed">
      <a routerLink="/admin/csv">
        <mat-icon class="material-icons">upload</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.triggercsv">
            trigger export
          </p>
        </div>
      </a>
    </div>
    <div *ngIf="commandUploadsAllowed">
      <a routerLink="/admin/commands">
        <mat-icon class="material-icons">drive_folder_upload</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.commanduploads">
            Command Uploads
          </p>
        </div>
      </a>
    </div>
    <div *ngIf="bulkAllowed">
      <a routerLink="/admin/admin-panel-bulk">
        <mat-icon class="material-icons">ballot</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.bulk">Bulk</p>
        </div>
      </a>
    </div>
    <div *ngIf="lomImportAllowed">
      <a routerLink="/admin/import-buildings">
        <mat-icon class="material-icons">download</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.importlom">Import from LOM</p>
        </div>
      </a>
    </div>
    <div *ngIf="settingsAllowed">
      <a routerLink="/admin/settings">
        <mat-icon class="material-icons">settings</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.settings">Settings</p>
        </div>
      </a>
    </div>
    <div *ngIf="maintenancemessagesAllowed">
      <a routerLink="/admin/maintenancemessages">
        <mat-icon class="material-icons">message</mat-icon>
        <div class="bottom-box">
          <p class="label" i18n="@@admin.panel.navigation.settings">Maintenance Messages</p>
        </div>
      </a>
    </div>
  </div>
</div>
